;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { z } from "zod/v4";
import {
	onboardingWorkspaceNameSchema,
	onboardingWorkspaceViewsSchema,
} from "@/lib/schema/auth";
import { multipleCompleteTeamMemberSchema } from "@/lib/schema/team";
import { UserRole } from "@/types/user";
import { ViewStatus } from "@/types/workspace";

export const createWorkspaceSchema = z.object({
	name: onboardingWorkspaceNameSchema.shape.workspaceName,
	teamMembers: multipleCompleteTeamMemberSchema,
	views: onboardingWorkspaceViewsSchema,
});

export const inviteWorkspaceUsersSchema = z.object({
	users: multipleCompleteTeamMemberSchema,
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

export const resendWorkspaceUserInvitationSchema = z.object({
	emails: z.array(z.email()).min(1, { error: "User email is required" }),
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

export const deleteWorkspaceUserSchema = z.object({
	userId: z.string().min(1, "User ID is required"),
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

export const bulkDeleteWorkspaceUsersSchema = z.object({
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
	workspaceUserIds: z
		.array(z.string().min(1))
		.min(1, { error: "At least one user ID is required" }),
});

export const editWorkspaceUserSchema = z.object({
	data: z.object({
		permissions: z.array(
			z.looseObject({
				canCreate: z.boolean(),
				canDelete: z.boolean(),
				canEdit: z.boolean(),
				canView: z.boolean(),
			}),
		),
		role: z.enum(UserRole),
	}),
	userId: z.string().min(1, "User ID is required"),
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

export const editWorkspaceSchema = z.object({
	name: z.string().trim().min(1, "Workspace name is required"),
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

export const addWorkspaceDashboardViewSchema = z.object({
	views: onboardingWorkspaceViewsSchema,
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

export const deleteWorkspaceDashboardViewSchema = z.object({
	viewId: z.string().min(1, { error: "View ID is required" }),
	workspaceId: z.string().min(1, { error: "Workspace ID is required" }),
});

// Base schema without refinements - can be used with .omit(), .pick(), .extend()
export const editWorkspaceDashboardViewBaseSchema =
	deleteWorkspaceDashboardViewSchema.extend({
		description: z.string().optional(),
		name: z.string().optional(),
		status: z.enum(ViewStatus).optional(),
	});

// Refined schema for form validation - ensures at least one field is provided
export const editWorkspaceDashboardViewSchema =
	editWorkspaceDashboardViewBaseSchema.refine(
		(data) => Object.values(data).some((v) => v !== undefined),
		{
			message: "At least one field must be provided.",
		},
	);

export type InviteWorkspaceUserSchema = z.infer<
	typeof inviteWorkspaceUsersSchema
>;

export type CreateWorkspaceSchema = z.infer<typeof createWorkspaceSchema>;

export type DeleteWorkspaceUserSchema = z.infer<
	typeof deleteWorkspaceUserSchema
>;

export type BulkDeleteWorkspaceUsersSchema = z.infer<
	typeof bulkDeleteWorkspaceUsersSchema
>;

export type EditWorkspaceUserSchema = z.infer<typeof editWorkspaceUserSchema>;
export type EditWorkspaceSchema = z.infer<typeof editWorkspaceSchema>;

export type AddWorkspaceDashboardViewSchema = z.infer<
	typeof addWorkspaceDashboardViewSchema
>;

export type DeleteWorkspaceDashboardViewSchema = z.infer<
	typeof deleteWorkspaceDashboardViewSchema
>;

export type EditWorkspaceDashboardViewSchema = z.infer<
	typeof editWorkspaceDashboardViewSchema
>;

export type ResendWorkspaceUserInvitationSchema = z.infer<
	typeof resendWorkspaceUserInvitationSchema
>;
